import type { IsSummaryWorthyDataFetchSource } from "owa-copilot-meeting-prep-utils";
import type { MailboxInfo } from "owa-client-types";
import { action } from "satcheljs";
import { type UTCalendarUIContext } from "@outlook/unified_telemetry";

export interface FetchIsMeetingSummaryWorthyActionMessage {
    meetingId: string;
    dataFetchSource: IsSummaryWorthyDataFetchSource;
    mailboxInfo: MailboxInfo;
    locationTag: number;
    uiContext?: UTCalendarUIContext;
}

export const fetchIsMeetingSummaryWorthy: (meetingId: string, dataFetchSource: IsSummaryWorthyDataFetchSource, mailboxInfo: MailboxInfo, locationTag: number, uiContext?: UTCalendarUIContext) => FetchIsMeetingSummaryWorthyActionMessage = action("fetchIsMeetingSummaryWorthy", (meetingId: string, dataFetchSource: IsSummaryWorthyDataFetchSource, mailboxInfo: MailboxInfo, locationTag: number, uiContext?: UTCalendarUIContext): FetchIsMeetingSummaryWorthyActionMessage => ({
    meetingId,
    dataFetchSource,
    mailboxInfo,
    locationTag,
    uiContext,
}));
